import { rokidBaseUrl ,modelServiceUrl} from "@rokid/host";
import type {
  IPostGetUserModelCompanyListReq,
  IPostGetUserModelCompanyListRes,
  IPostGetModelSupplierListRes,
  IPostCreateUserModelReq,
  IPostCreateUserModelRes,
  IPostUpdateUserModelReq,
  IPostUpdateUserModelRes,
} from "./model.d";
import {
  request,
  type IRequest,
  type IResult,
  type pageData,
} from "@rokid/utils";
import {
  modelSupplier,
  supplierModelItem,
} from "../../types/model";

//获取模型供应商列表
export const getModelCompanyList: IRequest<undefined, modelSupplier[]> = () => {
  return request({
    //url: `${rokidBaseUrl}/model/developer/getModelCompanyList`,
    url: `${modelServiceUrl}/developer/getModelCompanyList`,
    method: "post",
  }).then((res) => res.data);
};

/**
 * 获取模型供应商列表 //todo 此接口需要和上面的合并为1个
 */
export const getModelSupplierList: IRequest<
  undefined,
  IPostGetModelSupplierListRes
> = (data) => {
  return request({
    //url: `${rokidBaseUrl}/model/user/developer/getModelCompanyList`,
    url: `${modelServiceUrl}/developer/getModelCompanyList`,
    method: "post",
    data,
  }).then((res) => res);
};

/**
 * 获取开发者自定义的模型供应商列表
 * export const getModelSupplierList: IRequest<any, pageData<customModelSupplier>> = (data) => {
 */
export const getModelList: IRequest<
  IPostGetUserModelCompanyListReq,
  IPostGetUserModelCompanyListRes
> = (data) => {
  return request({
    //url: `${rokidBaseUrl}/model/user/developer/getUserModelCompanyList`,
    url: `${modelServiceUrl}/developer/getUserModelCompanyList`,
    method: "post",
    data,
  });
};

//删除开发者自定义模型
export const deleteUserModelCompany: IRequest<number, any> = (id) => {
  return request({
    //url: `${rokidBaseUrl}/model/user/developer/deleteUserModelCompany`,
    url: `${modelServiceUrl}/developer/deleteUserModelCompany`,
    method: "post",
    data: { id },
  });
};

//获取供应商下的模型列表
export const getUserModelList: IRequest<number, pageData<supplierModelItem>> = (
  userModelCompanyId
) => {
  return request({
    //url: `${rokidBaseUrl}/model/user/developer/getUserModelList`,
    url: `${modelServiceUrl}/developer/getUserModelList`,
    method: "post",
    data: { userModelCompanyId },
  }).then((res) => res.data);
};

//开启或关闭 供应商的某个模型
export const switchModalEnable: IRequest<{ string: boolean }, any> = (cfg) => {
  return request({
    //url: `${rokidBaseUrl}/model/user/developer/batchUpdateUserModelEnable`,
    url: `${modelServiceUrl}/developer/batchUpdateUserModelEnable`,
    method: "post",
    data: { enableMap: cfg },
  });
};

/**
 * 新增开发者自定义模型
 */
export const createUserModel: IRequest<
  IPostCreateUserModelReq,
  IPostCreateUserModelRes
> = (data) => {
  return request({
    //url: `${rokidBaseUrl}/model/user/developer/addUserModelCompany`,
    url: `${modelServiceUrl}/developer/addUserModelCompany`,
    method: "post",
    data,
  }).then((res) => res);
};

/**
 * 更新开发者自定义模型
 */
export const updateUserModel: IRequest<
  IPostUpdateUserModelReq,
  IPostUpdateUserModelRes
> = (data) => {
  return request({
    //url: `${rokidBaseUrl}/model/user/developer/updateUserModelCompany`,
    url: `${modelServiceUrl}/developer/updateUserModelCompany`,
    method: "post",
    data,
  }).then((res) => res);
};
